import { RouteRecordRaw } from "vue-router";

export const message: RouteRecordRaw = {
  path: "/message",
  component: () =>
    import(/* webpackChunkName: "message" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "message-rooms",
      name: "MessageRooms",
      component: () =>
        import(
          /* webpackChunkName: "message" */ "@/views/message/MessageRooms.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "informations",
      name: "Informations",
      component: () =>
        import(
          /* webpackChunkName: "message" */ "@/views/message/Informations.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "message-rooms/:officeId",
      name: "MessageRoomDetail",
      component: () =>
        import(
          /* webpackChunkName: "message" */ "@/views/message/MessageRoomDetail.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "informations/:informationId",
      name: "InformationDetail",
      component: () =>
        import(
          /* webpackChunkName: "message" */ "@/views/message/InformationDetail.vue"
        ),
      meta: {
        isBeforeLogin: false
      }
    }
  ]
};
